<template>
  <div v-if="guidelineImage" class="guideline-image-container">
    <div class="guideline-content">
      <img :src="guidelineImage" alt="guideline_img" />
    </div>
  </div>
</template>

<script lang="ts">
import { computed, Ref } from 'vue';
import { useStore } from 'vuex';
import { Question } from 'altru-types';

export default {
  name: 'GuidelineOverlay',
  setup(): { guidelineImage: Ref<string | undefined> } {
    const store = useStore();
    const questionInfo: Ref<Question> = computed(() => store.getters['questions/questionInfo']);
    const guidelineImage: Ref<string | undefined> = computed(() => questionInfo.value.guideline_image_url);

    return {
      guidelineImage,
    };
  },
};
</script>

<style lang="scss" scoped>
.guideline-image-container {
  bottom: 0;
  left: 0;
  position: absolute;
  overflow: hidden;
  right: 0;
  top: 0;
  z-index: 1;
  pointer-events: none;

  &:after {
    background: linear-gradient(
        to top,
        rgba(0, 0, 0, 1) 0,
        rgba(0, 0, 0, 0.25) 40%,
        rgba(0, 0, 0, 0) 85%,
        rgba(0, 0, 0, 0) 0
      )
      100% 50% / 100% 100% repeat-x;
    border-bottom-left-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
    bottom: 0;
    content: '';
    height: 25%;
    left: 0;
    pointer-events: none;
    position: absolute;
    right: 0;
    width: 100%;
  }

  .guideline-content {
    img {
      border-radius: 0.5rem;
      height: auto;
      width: 100%;
      max-height: 100%;
      position: absolute;
      left: 50%;
      top: 50%;
      bottom: 0;
      right: 0;
      transform: translate(-50%, -50%);
      object-fit: contain;
      opacity: 0.5;
    }
  }
}
</style>
